module.exports = __webpack_public_path__ + "img/A2030_gold-rate.83c46d9b.jpg";